import React, { Component } from "react";

class BasePage extends Component {
  getHead() {
    return// <>Head</>;
  }

  getFooter() {
    return //<>Footer</>;
  }

  getFooterAndHeader() {
    return {
      header: this.getHead(),
      footer: this.getFooter(),
    };
  }

  renderPage(content) {
    const { header, footer } = this.getFooterAndHeader();

    return (
      <>
        {header}
        {content}
        {footer}
      </>
    );
  }

  renderPageWithMain(content) {
    const { header, footer } = this.getFooterAndHeader();
    return (
      <>
        {header}
        <main>{content}</main>
        {footer}
      </>
    );
  }
}

export default BasePage;
